export default __webpack_public_path__ + "static/media/logo-white.5fda4639.png";